import { createAction } from "redux-actions";

export const LOGOUT = "logout/LOG_OUT";

export const logout = createAction(LOGOUT);
